// extracted by mini-css-extract-plugin
export var checkbox = "_2z-0";
export var circle = "_2z-3";
export var horizontalContainer = "_2z-7";
export var sm = "_2z-5";
export var switch0 = "_2z-2";
export var switchDisabled = "_2z-8";
export var switchEnabled = "_2z-1";
export var textSwitchContainer = "_2z-9";
export var textSwitchOption = "_2z-a";
export var textSwitchOptionSelected = "_2z-b";
export var verticalContainer = "_2z-6";
export var xs = "_2z-4";